import React from "react";
import styled from "styled-components";
import { greyText } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { CompassProgressBar } from "../CompassProgressBar";

const ProgressRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

const Label = styled(CompassParagraph)<{ minWidth?: number }>`
  font-size: 13px;
  color: ${greyText};
  margin: 0;
  min-width: ${({ minWidth }): number => minWidth ?? 100}px;
`;

const ProgressWrapper = styled.div`
  flex: 1;
`;

const ValueText = styled(CompassParagraph)`
  margin: 0;
  font-size: 12px;
  color: ${greyText};
  min-width: 32px;
  text-align: right;
`;

export interface ModalProgressRowProps {
  /** Label text */
  label: string;
  /** Progress value (0-100) */
  value: number;
  /** Maximum value (default: 100) */
  max?: number;
  /** Show percentage text (default: true) */
  showPercentage?: boolean;
  /** Progress bar height (default: 6) */
  height?: number;
  /** Label minimum width (default: 100) */
  labelMinWidth?: number;
}

/**
 * A row with label, progress bar, and optional percentage display
 */
export const ModalProgressRow: React.FC<ModalProgressRowProps> = ({
  label,
  value,
  max = 100,
  showPercentage = true,
  height = 6,
  labelMinWidth,
}) => {
  const percentage = Math.round((value / max) * 100);

  return (
    <ProgressRowContainer>
      <Label minWidth={labelMinWidth}>{label}</Label>
      <ProgressWrapper>
        <CompassProgressBar value={value} max={max} height={height} />
      </ProgressWrapper>
      {showPercentage && <ValueText>{percentage}%</ValueText>}
    </ProgressRowContainer>
  );
};
